import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminAffiliates from "@/pages/AdminAffiliates";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/affiliates")({
  head: () => seoHead("/admin/affiliates"),
  component: () => (
    <AdminGate><AdminAffiliates /></AdminGate>
  ),
});
